export function ActionButton({ onClick, children, disabled, primary, c }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        background: primary ? c.text : "transparent",
        color: primary ? c.bg : c.textSecondary,
        border: primary ? "none" : `1px solid ${c.border}`,
        borderRadius: "8px",
        cursor: disabled ? "not-allowed" : "pointer",
        padding: primary ? "9px 18px" : "6px 12px",
        fontSize: primary ? 14 : 12,
        fontWeight: primary ? 500 : 400,
        opacity: disabled ? 0.4 : 1,
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
      }}
    >
      {children}
    </button>
  );
}

export function DropdownItem({ onClick, selected, children, last, c }) {
  return (
    <div
      onClick={onClick}
      style={{
        padding: "10px 14px",
        fontSize: 13,
        cursor: "pointer",
        background: selected ? c.bgSecondary : c.bg,
        color: c.text,
        borderBottom: last ? "none" : `1px solid ${c.border}`,
        fontWeight: selected ? 600 : 400,
      }}
    >
      {children}
    </div>
  );
}

export function DictationButton({ fieldKey, short, isRecording, recordingTarget, stopDictation, startDictation, c, dark }) {
  const active = isRecording && recordingTarget === fieldKey;
  return (
    <button
      onClick={() => (active ? stopDictation() : startDictation(fieldKey))}
      style={{
        border: `1px solid ${active ? "#fc8181" : c.border}`,
        background: active ? (dark ? "#2d1515" : "#fff5f5") : "transparent",
        color: active ? c.danger : c.textSecondary,
        borderRadius: "8px",
        cursor: "pointer",
        padding: "5px 10px",
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: "50%",
          background: active ? c.danger : c.borderSecondary,
          display: "inline-block",
          animation: active ? "blink 1.2s infinite" : "none",
        }}
      />
      {active ? "Stop" : (short ? "🎤" : "🎤")}
    </button>
  );
}
